type FormField = {
    label: string;
    name: string;
    type: string;
};

type BankId = 5 | 6 | 7 | 10 | 19;

type BankExtraParams = {
    [key in BankId]: FormField[];
};

export const bankExtraParams: BankExtraParams = {
    5: [
        { label: "Hesap No", name: "extraParam1", type: "text" },
        { label: "Ürün Kodu", name: "extraParam2", type: "text" },
        {label: "Başak Sorgu", name: "extraParam3", type: "text"}
    ],
    6: [
        { label: "Imc Kod", name: "extraParam1", type: "text" },
        { label: "F Dönem", name: "extraParam2", type: "text" },
        { label: "Bölüm No", name: "extraParam3", type: "text" },
        { label: "Safir Üye İşyeri Varsayılan Bölüm No", name: "extraParam4", type: "text" }
    ],
    7: [
        { label: "Maturity Period", name: "extraParam1", type: "text" },
        { label: "Frequency", name: "extraParam2", type: "text" }
    ],
    10: [
        { label: "FlexInstall Info", name: "extraParam1", type: "text" },
        { label: "Maturity Period", name: "extraParam2", type: "text" },
        { label: "Payment Frequency", name: "extraParam3", type: "text" }
    ],
    19: [
        { label: "Öteleme Ay Sayısı", name: "extraParam1", type: "number" }
    ]
};
